// extracted by mini-css-extract-plugin
export default {"imageWrapper":"GG-z","twoColumnImage":"HG-z"};